// const wrapper = document.querySelector('search-button.search-action.mobile\\:hidden');
// const button = document.querySelector('search-button.search-action.mobile\\:hidden button');

// wrapper?.addEventListener('click', (e) => {
//   console.log('wrapper clicked', e);
// });

// button?.addEventListener('click', (e) => {
//   console.log('button clicked', e);
// });


document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-open-search-modal]');
  if (!btn) return;

  e.preventDefault();

  const modal = document.getElementById('search-modal');
  if (!modal || typeof modal.showDialog !== 'function') return;

  modal.showDialog();
});


$(document).ready(function() {
    $('section#cta-template--21349151670531__cta_above_footer_two_kVCaEi .CTA-section-bottom-box .CTA-button-box a:nth-child(1)').attr('target', '_blank');
});